

import * as api from "../../constant/NewAPI";
import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import Utils from "../../constant/Utils";

// import * as api from "../../constant/API";

const Counts = () => {

    const [sportList, setSportList] = useState([]);
    const [countInstitutes, setCountInstitutes] = useState("");
    const [countStudents, setCountStudents] = useState("")
    const [searchInput, setSearchInput] = useState("");

    useEffect(() => {
        insCounts();
        insSportCount();
    }, [])

    function insCounts() {
        const getCount = api.instStudCounts;
        fetch(getCount, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((cntResponse) => cntResponse.json())
            .then((cntResult) => {
                if (cntResult.error == true) {
                    if (cntResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    setCountInstitutes(cntResult.data.InstitutionCount);
                    setCountStudents(cntResult.data.studentCount);
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the Institutes and Students count", error);
            })
    }

    function insSportCount() {
        const getInsSprtCount = api.instStudCountSprt;
        fetch(getInsSprtCount, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((insResponse) => insResponse.json())
            .then((insResult) => {
                setSportList(insResult.data)
            })
            .catch((error) => {
                console.log("Failed to fetch the institute student count list", error)
            })
    }

    const filteredData = sportList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData) => {
        return <span>{rowData.sportId}</span>;
    };

    const sportRender = (rowData) => {
        return <span>{rowData.sportName}</span>;
    };

    const coachRender = (rowData) => {
        return <span>{rowData.sportCoachCount}</span>;
    };

    const studentCountRender = (rowData) => {
        return <span>{rowData.sportStudentCount}</span>;
    };

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row">
                                <div className="col-md-3"></div>
                                <div className="col-xl-3 col-lg-6 col-md-6 d-flex">
                                    <div className="statistics-grid flex-fill">
                                        <div className="statistics-content">
                                            <p className="text-uppercase">Institutes</p>
                                            <h3>{countInstitutes}</h3>
                                        </div>
                                        <div className="statistics-icon">
                                            <ImageWithBasePath
                                                src="assets/img/Tenvic/Institution.png"
                                                alt="Icon"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-6 col-md-6 d-flex">
                                    <div className="statistics-grid flex-fill">
                                        <div className="statistics-content">
                                            <p className="text-uppercase">Students</p>
                                            <h3>{countStudents}</h3>
                                        </div>
                                        <div className="statistics-icon">
                                            <ImageWithBasePath
                                                src="assets/img/Tenvic/graduate.png"
                                                alt="Icon"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="table-responsive">
                                    <table className="table table-datatble">
                                        <thead>
                                            <tr>
                                                <th className="text-uppercase">Sl No</th>
                                                <th className="text-uppercase">Sport</th>
                                                <th className="text-uppercase">Coach</th>
                                                <th className="text-uppercase">Student</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(sportList) && sportList.map((sport, index) => (
                                                <tr key={index}>
                                                    <td>{sport.sportId}</td>
                                                    <td>{sport.sportName}</td>
                                                    <td>{sport.sportCoachCount}</td>
                                                    <td>{sport.sportStudentCount}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-md-6">
                                </div>
                                <div className="col-md-6">
                                    <div className="dataTables_filter text-end mb-10">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                </div>

                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slno"
                                                    header="Sl No"
                                                    body={slNoRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="sportName"
                                                    header="Sport"
                                                    body={sportRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="sportCoachCount"
                                                    header="Coach"
                                                    body={coachRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="sportStudentCount"
                                                    header="Student"
                                                    body={studentCountRender}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default Counts;